import Skeleton from '@discover-ui/skeleton';
import Stars from '@discover-components/restaurant/rating/stars';
import Root, { type RootProps } from './root';

export default function RestaurantRatingSkeleton({ ...props }: Omit<RootProps, 'children'>) {
  return (
    <Root {...props}>
      <Skeleton>5.0</Skeleton>
      <Stars className="mx-1.5 text-skeleton" count={5} />
      <Skeleton>(100)</Skeleton>
    </Root>
  );
}
